import './editable-name-box.component.scss';

import { memo, useState } from 'react';

import InputWithIcon from '../InputWithIcon';

const EditableNameBox = props => {
  const {
    containerClassName,
    inputFieldOnKeyDown,
    inputFieldOnChange,
    inputFieldOnClick,
    onClickCancelIcon,
    value,
    minLength,
    maxLength,
    disabled,
    ...other
  } = props;

  const [isEdit, setIsEdit] = useState(false);
  const currentValue = value === null || value === undefined ? '' : String(value).trimStart();
  const currentMinLength = minLength === null || value === undefined ? '' : minLength;
  const currentMaxLength = maxLength === null || value === undefined ? '' : maxLength;

  return (
    <div className={`editable-field ${containerClassName} `} {...other}>
      {
        disabled && <div>{currentValue}</div>
      }
      {
        !disabled &&
        <>
          <span
            className={`name-field ${isEdit ? 'd-none' : 'd-inline-block'}`}
            onClick={() => setIsEdit(true)}
          >
            {currentValue}
          </span>
          <div className={`input-field ${isEdit ? 'd-block' : 'd-none'}`}>
            <InputWithIcon
              type='text'
              value={currentValue}
              minLength={currentMinLength}
              maxLength={currentMaxLength}
              iconClassName='icon-close'
              iconOnClick={() => {
                setIsEdit(false);

                if (onClickCancelIcon) {
                  onClickCancelIcon();
                }
              }}
              onClick={inputFieldOnClick}
              onChange={inputFieldOnChange}
              onKeyDown={e => {
                if (!currentValue || currentValue.length === 0) {
                  return;
                }
                if (e.key === 'Enter') {
                  setIsEdit(false);

                  if (inputFieldOnKeyDown) {
                    inputFieldOnKeyDown(e);
                  }
                }
              }}
            />
          </div>
        </>
      }
    </div>
  );
};

export default memo(EditableNameBox);
